import { Col, Row } from 'react-bootstrap';
import { Line } from 'rc-progress';

export default function Progress({ progress = 0 }) {
  return (

    <Col className="text-end" style={{ marginBottom: '0', paddingBottom: '0', border: '1px solid #00A261', borderRadius: '5px' }}>
      <Row className="">
        <Col style={{ marginBottom: '0', paddingBottom: '0' }}>
          <p>Progress </p>
        </Col>
        <Col style={{ marginBottom: '0', paddingBottom: '0' }}>
          <p className='text-end'>{progress}%</p>
        </Col>
      </Row>
      <Row className=''>
        <Col >
          <Line percent={progress} strokeWidth={2} strokeColor="#00A261" />
        </Col>
      </Row>
    </Col>
  );
}